import { h } from 'preact';
export const Delete = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z" }),
        h("line", { x1: "18", y1: "9", x2: "12", y2: "15" }),
        h("line", { x1: "12", y1: "9", x2: "18", y2: "15" })));
};
//# sourceMappingURL=delete.js.map